
import React, { useState, useEffect } from 'react';
import { ComboBox, Dropdown, Button, TextInput, InlineNotification, NotificationActionButton, TileGroup, RadioTile, Modal, Loading, SkeletonPlaceholder, InlineLoading } from 'carbon-components-react';
import { useHistory } from 'react-router-dom';
import i18n from "../../i18n";
import * as Constants from '../../requests/URLConstants'
import callPostApi from "../../requests/PostRequests";
import { Breadcrumb, BreadcrumbItem } from 'carbon-components-react';
import { ArrowRight16, Edit16, Calendar16, Add16 } from "@carbon/icons-react";
import ConflictingScheduleTable from './ConflictingScheduleTable';
import AddParameter from './AddParameter';
import callGetApi from '../../requests/GetRequests';
import axios from "axios";
import * as MockData from './mock.json';




require("./_run-automata.scss");

const CreateRunAutomataPage = props => {

    const title = i18n.t('runAutomata.title');
    const runAutomata = i18n.t('runAutomata.runAutomata');
    const pickAnAutomata = i18n.t('runAutomata.pickAnAutomata');
    const editParametersLabel = i18n.t('runAutomata.editParametersLabel');
    //const flagLabel = i18n.t('runAutomata.flagLabel');
    //const countLabel = i18n.t('runAutomata.countLabel');
    const runLabel = i18n.t('runAutomata.runLabel');
    const nextLabel = i18n.t('runAutomata.nextLabel');
    const chooseLabel = i18n.t('runAutomata.chooseLabel');
    const automataDropdownLabel = i18n.t('runAutomata.automataDropdownLabel');
    const automataDropdownTitle = i18n.t('runAutomata.automataDropdownTitle');
    const recomendedResource = i18n.t('runAutomata.recomendedResource');
    const resourceName = i18n.t('runAutomata.resourceName');
    const home = i18n.t('qualityCode.Home');
    const overrideLabel = i18n.t('runAutomata.override');
    const slotLabel = i18n.t('runAutomata.availableSlot');
    const addLabel = i18n.t('runAutomata.addLabel');

    const nameLabel = i18n.t('runAutomata.nameLabel');
    const valueLabel = i18n.t('runAutomata.valueLabel');
    const typeLabel = i18n.t('runAutomata.typeLabel');
    const namePlaceholder = i18n.t('runAutomata.namePlaceholder');
    const valuePlaceholder = i18n.t('runAutomata.valuePlaceholder');
    const typePlaceholder = i18n.t('runAutomata.typePlaceholder');
    const parameterLabel = i18n.t('runAutomata.parameterLabel');
    const ExpectedAutomataRunDuration = i18n.t('runAutomata.ExpectedAutomataRunDuration');
    const SelectAutomata = i18n.t('runAutomata.SelectAutomata');
    const waitingLabel = i18n.t('runAutomata.waitingLabel');
    const LoadingLabel = i18n.t('runAutomata.Loading');
    const VmDetailsNotFound = i18n.t('runAutomata.VmDetailsNotFound');
    const Cancel = i18n.t('runAutomata.Cancel');
    const Warning = i18n.t('runAutomata.Warning');
    const overrideExistingSchedule = i18n.t('runAutomata.overrideExistingSchedule');
    const Run = i18n.t('runAutomata.Run');
    const ResourceUnavailable = i18n.t('runAutomata.ResourceUnavailable');

    const [message, setMessage] = useState('');
    const [automata, setAutomata] = useState('');
    const [flag, setFlag] = useState('false');
    const [count, setCount] = useState('');
    const [automataEditMode, setAutomataEditMode] = useState(false);
    const [parameterNotAvailableOnlyDuration, setParameterNotAvailableOnlyDuration] = useState(true);
    const [resourceUnavailable, setResourceUnavailable] = useState(false);
    const [editResource, setEditresource] = useState(false);
    const [showAvailableSlot, setShowAvailableSlot] = useState(false);
    const [showAddParameter, setShowAddParameter] = useState(false);
    const [parameterlength, setParameterlength] = useState(0);
    const [showOverrideModal, setShowOverrideModal] = useState(false);
    const [automataList, setAutomataList] = useState([]);
    const [availableParameter, setAvailableParameter] = useState([]);
    const [expectedDuration, setExpectedDuration] = useState("");
    const [selectedItems, setSelectedItem] = useState([]);
    const [automataLoading, setAutomataLoading] = useState(true);
    const [parameterLoading, setParameterLoading] = useState(true);
    const [showResource, setShowResource] = useState(false);
    const [appStack, setAppStack] = useState({});
    const [recommendResourceList, setRecommendResourceList] = useState([]);
    const [VMResponse, setVMResponse] = useState([]);
    const [selectedResource, setSelectedResource] = useState('');
    const [VMModalOpen, setVMModalOpen] = useState(false);
    const [resourceLoading, setResourceLoading] = useState(false);
    const [runautomataLoading, setRunautomataLoading] = useState(false);
    const [automataRunList, setAutomataRunList] = useState([]);
    const [successModal, setSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');

    let history = useHistory();

    useEffect(() => {
        getAutomataList();
    }, [parameterlength, parameterNotAvailableOnlyDuration, showAddParameter, availableParameter, expectedDuration]);

    useEffect(() => {
        if (automataList.length > 0 && props.incidentAutomata === true) {
            var filtered = [];
            for (let i = 0; i < automataList.length; i++) {
                if (automataList[i].name === props.automatakey.name) {
                    filtered.push(automataList[i]);
                    break;
                }

            }
            setAutomataRunList(filtered);
            //setAutomata(filtered);
            const bodyVM = {
                "automata_busn_key": props.automatakey.busn,
            }
            getVMDetails(bodyVM);
        }

    }, [automataList]);

    useEffect(() => {
        if (successMessage !== '')
            setSuccessModal(!successModal);
    }, [successMessage])

    useEffect(() => {
        setAutomataLoading(false);
        //console.log(availableParameter)
    }, [availableParameter]);

    const getBuisnessOwnerRights = (automataName, automataBusn) => {
        let user = JSON.parse(localStorage.getItem('user'));

        const body = {
            "automataName": automataName,
            "userId": user.username
        }
        callPostApi(Constants.GETBUISNESSOWNERRIGHTS, {
            'Content-Type': 'application/json'
        }, body).then(resp => {
            if (resp && resp.usermatch === true) {
                const bodyVM = {
                    "automata_busn_key": automataBusn,
                }
                getVMDetails(bodyVM);
            } else {
                // Open a Modal user dowsn't have rights.
            }
        }).catch((error) => {
        });
    }

    const getAutomataList = () => {
        setAutomataLoading(true);
        let user = JSON.parse(localStorage.getItem('user'));
        let isAdmin;

        let roles = JSON.parse(localStorage.getItem('roles'));
        if (roles && roles.includes("L1L2_Support") === true) {
            isAdmin =  true;
        } else {
            isAdmin = false;
        }

        let body = {
            "userId": user.username,
            "isAdmin": isAdmin
        }

        callPostApi(Constants.GETAUTOMATANAMESLIST, {
            'Content-Type': 'application/json'
        }, body).then(resp => {
            let automataList = [];

            if (resp) {
                //setAutomataLoading(false);
                resp.forEach(element => {
                    let automata = {};
                    automata.name = element.automata_nm;
                    automata.franchise = element.acct_typ_nm;
                    automata.apphost = element.app_host_machine_nm;
                    automata.busn = element.automata_busn_key;
                    automata.client = element.party_nm;
                    automataList.push(automata);
                });

                //console.log("automataList",automataList);

                setAutomataList(automataList);
                setParameterLoading(false);
            }
        }).catch((error) => {
            setAutomataLoading(false);
        });
        // callGetApi(Constants.GETAUTOMATALIST, {
        //     'Content-Type': 'application/json'
        // }).then(resp => {
        //     let automataList = [];

        //     if (resp) {
        //         //setAutomataLoading(false);
        //         resp.forEach(element => {
        //             let automata = {};
        //             automata.name = element.key.automata_name;
        //             automata.franchise = element.key.acct_type_name;
        //             automata.apphost = element.key.app_host_machine_nm;
        //             automata.busn = element.key.automata_busn_key;
        //             automata.client = element.key.party_name;
        //             automataList.push(automata);
        //         });

        //         //console.log("automataList",automataList);

        //         setAutomataList(automataList);
        //         setParameterLoading(false);
        //     }
        // }).catch(error => {
        //     setAutomataLoading(false);

        // });
    }

    function setSelectedAutomata(e) {

        if (e.selectedItem !== null) {
            setAutomata(e.selectedItem);
            console.log("automata details", e.selectedItem);
            // const body = {
            //     "automatakey": e.selectedItem.busn,
            // }
            // getAppStack(body);


            const bodyVM = {
                "automata_busn_key": e.selectedItem.busn,
            }
            getVMDetails(bodyVM);

            // getBuisnessOwnerRights(e.selectedItem.name,e.selectedItem.busn );

        }
    }

    function getAutomataInfo() {
        let body = {};
        if (props.incidentAutomata === true) {
            body = {
                "automatakey": props.automatakey.busn,
            }
        }
        else {
            body = {
                "automatakey": automata.busn,
            }
        }
        callPostApi(Constants.GETAUTOMATAPARAMS, {
            'Content-Type': 'application/json'
        }, body).then(resp => {
            if (resp) {
                if (resp.length === 0) {
                    setShowAddParameter(true);
                    setAutomataLoading(false);
                    setAvailableParameter(resp);
                }
                else setShowAddParameter(false);
                setAvailableParameter(resp);
            }
        }).catch((error) => {
            setAutomataLoading(false);
        });
        callPostApi(Constants.GETEXPECTEDDURATION, {
            'Content-Type': 'application/json'
        }, body).then(resp => {
            if (resp) {
                setExpectedDuration(resp.expected_duration)
            }
        }).catch((error) => {
            setAutomataLoading(false);
        });
    }

    function setSelectedAutomataResource(e) {
        if (e.selectedItem !== null) {
            console.log("Resource", e.selectedItem);
            setSelectedResource(e.selectedItem);
        }

    }

    const getRecommendedResource = () => {
        setShowResource(true);
        // let currentTime = currentDate.getHours() + ":" + currentDate.getMinutes() + ":" + currentDate.getSeconds();
        let timeAfter5Mins = new Date();
        timeAfter5Mins = new Date(timeAfter5Mins.setMinutes(timeAfter5Mins.getMinutes() + 5));
        let rangeStartTime = timeAfter5Mins.getHours() + ":" + timeAfter5Mins.getMinutes() + ":" + timeAfter5Mins.getSeconds();
        let EndTime = new Date(timeAfter5Mins.setMinutes(timeAfter5Mins.getMinutes() + 5 + expectedDuration));
        let rangeEndTime = EndTime.getHours() + ":" + EndTime.getMinutes() + ":" + EndTime.getSeconds();
        //console.log("range_end_time", rangeEndTime);

        let currentDate = new Date();
        let endDate = currentDate.setDate(currentDate.getDate() + 1);
        endDate = new Date(endDate).toISOString();
        // Add a day

        console.log("onboard_life_start_time", new Date().toISOString());
        console.log("onboard_life_end_time", endDate);

        console.log("range_time_start", rangeStartTime);
        let automataname = '';
        let franchiseName = '';
        let hostName = '';
        let clientName = '';
        if (props.incidentAutomata === true) {
            automataname = props.automatakey.name;
            franchiseName = props.automatakey.franchise;
            hostName = props.automatakey.apphost;
            clientName = props.automatakey.client;
        }
        else {
            automataname = automata.name;
            franchiseName = automata.franchise;
            hostName = automata.apphost;
            clientName = automata.client;
        }
        // "onboard_life_end_time": endDate, //date.now + 1day


        let body = {
            "onboard_automata_name": automataname, //automata name
            "onboard_life_start_time": new Date().toISOString(), //date.now
            "onboard_life_end_time": "", //date.now + 1day
            "automata_execution_time": expectedDuration, //user input or execution time
            "onboard_automata_frequency": "once", //harcoded
            "frequency_value": 1, //hardcoded
            "range_time_start": rangeStartTime, //date.now only time + 5 mins
            "range_time_end": rangeEndTime, //range_time_start + expected duration
            "TopNBots": 200, //hardcoded
            "acct_type_name": franchiseName, //franchise name
            "apphost_name": hostName, //hostname
            "appstack_name": "", //appstack 
            "client_name": clientName, //client name
            "preferred_vm": VMResponse.preffered_vm_to_send, //
            "preferred_vm_list": VMResponse.list_vms ? VMResponse.list_vms.toString() : '',
            "tech_name": ""
        };

        if (VMResponse && VMResponse.list_vms && VMResponse.list_vms.length > 0) {
            setResourceLoading(true)

            callPostApi(Constants.GETRECOMMENDEDRESOURCES, {
                'Content-Type': 'application/json'
            }, body).then(resp => {
                if (resp) {
                    getRecommendedBotsAccordingtoScore(resp)
                }
                setResourceLoading(false)

            }).catch((error) => {
                setResourceLoading(false)

            });
        } else {
            if (VMResponse.preffered_vm_to_send) {
                let resourcelist = [];
                resourcelist.push(VMResponse.preffered_vm_to_send);
                setRecommendResourceList(resourcelist);
            }
            else setRecommendResourceList([]);

        }

    }

    const getRecommendedBotsAccordingtoScore = (recommendResource) => {

        let RecommendedBotsList = [];

        if (recommendResource && recommendResource.RecommendedBots && recommendResource.respectiveBotsScore) {
            recommendResource.respectiveBotsScore.forEach(function (element, index) {
                if (recommendResource.respectiveBotsScore[index] === 0) {
                    RecommendedBotsList.push(recommendResource.RecommendedBots[index]);
                }
            });
        }
        setRecommendResourceList(RecommendedBotsList);
    }


    const getRunStatus = (automataname) => {
        let body = {
            "automataName": automataname
        }

        callPostApi(Constants.GETRUNSTATUS, {
            'Content-Type': 'application/json'
        }, body).then(resp => {
        
            if(resp && resp.hits && resp.hits.hits[0] && resp.hits.hits[0]._source) {
                let jobId = resp.hits.hits[0]._source.job_id;
                return jobId;
              }
            
        }).catch((error) => {
        });
    }
    // const getAppStack = (body) => {
    //     callPostApi(Constants.GETAPPSTACK, {
    //         'Content-Type': 'application/json'
    //     }, body).then(resp => {
    //         // if (resp) {
    //         //     setAppStack(resp);
    //         // }else{
    //         //     getVMDetails();
    //         // }

    //         getVMDetails();

    //     }).catch((error) => {
    //     });
    // }

    const getVMDetails = (body) => {
        callPostApi(Constants.GETVM, {
            'Content-Type': 'application/json'
        }, body).then(resp => {
            if (resp) {
                //console.log(resp);
                setVMResponse(resp);
                // if Blank value then show pop up VM details not Found.
            }

        }).catch((error) => {
        });
    }

    const getResourceStatus = () => {
        const body = {
            "resourcekey": "",
        }
        callPostApi(Constants.GETRESOURCESTATUS, {
            'Content-Type': 'application/json'
        }, body).then(resp => {
            if (resp) {
            }
        }).catch((error) => {
        });
    }

    const getConflictingSchedule = () => {
        const body = {
            "resourcekey": "",
            "starttimekey": "",
            "endtimekey": ""
        }
        callPostApi(Constants.GETCONFLICTINGSCHEDULE, {
            'Content-Type': 'application/json'
        }, body).then(resp => {
            if (resp) {
            }
        }).catch((error) => {
        });
    }

    const openOverrideModal = () => {
        setShowOverrideModal(true);
    }
    const closeOverrideModal = () => {
        setShowOverrideModal(false);
    }

    let datatoRunAutomataElastic = {
        "automata_exe_resource": selectedResource, // "ACCMVP11DVHOST1"// selectedResource Hardcoding should be removed on Production
        "FranchiseName": props.incidentAutomata === true ? props.automatakey.franchise : automata.franchise,
        "AppHostName": props.incidentAutomata === true ? props.automatakey.apphost : automata.apphost, //"accmvp11dvhost1", //automata.apphost Hardcoding should be removed on Production
        "automata_inputs": "",
        "automata_name": props.incidentAutomata === true ? props.automatakey.name : automata.name,
        "tags": availableParameter
    }


    function handleSubmit() {
        //console.log(datatoRunAutomataElastic);
        console.log("automataList", automataList);
        setRunautomataLoading(true);

        callPostApi(Constants.RUNAUTOMATA, {
            'Content-Type': 'application/json'
        }, datatoRunAutomataElastic)
            .then(response => {
                // let response = MockData.default;
                if (response.Session && response.Session !== "") {
                    if (props.incidentAutomata === true) {
                        setRunautomataLoading(false);
                        props.showModal();
                        props.showMessage(response.Session);
                    }
                    else {
                        setRunautomataLoading(false);
                        setMessage(response.Session);
                        history.push({
                            pathname: '/completedRunAutomata',
                            session_no: response.Session
                        });
                    }
                }
                else if (response.RerunSuccess && response.RerunSuccess === "false") {
                    setRunautomataLoading(false);
                    history.push({
                        pathname: '/ExceptionRunAutomata'
                    });
                } else {
                    let id = setInterval(() => {
                        let automataName = props.incidentAutomata === true ? props.automatakey.name : automata.name;
                        let body = {
                            "automataName": automataName
                        }
                
                        callPostApi(Constants.GETRUNSTATUS, {
                            'Content-Type': 'application/json'
                        }, body).then(resp => {
                            let jobId = "";
                            if(resp && resp.hits && resp.hits.hits[0] && resp.hits.hits[0]._source) {
                                jobId = resp.hits.hits[0]._source.job_id;
                              }
                              if (jobId !== ""){
                                history.push({
                                    pathname: '/completedRunAutomata',
                                    session_no: jobId
                                }); 
                            }else {
                            setRunautomataLoading(false);
                            history.push({
                                pathname: '/ExceptionRunAutomata'
                            });
        
                            }
                            
                        }).catch((error) => {
                        });
                        }, 30000);
                      return () => clearInterval(id);                                        
                }
            }).catch(error => {
                setRunautomataLoading(false);
                history.push({
                    pathname: '/ExceptionRunAutomata'
                });
            });
    };

    function updateTextInputValue(event, param) {
        switch (param) {
            case 'flag':
                setFlag(event.target.value);
                break;
            case 'count':
                setCount(event.target.value);
                break;
            default:
                break;
        }
    }

    function editAutomata() {
        setAutomataEditMode(false);
        setAvailableParameter([]);
        setExpectedDuration("");
        setSelectedResource("");
        //setVMResponse([]);
        setShowResource(false);
    }

    function saveAutomata() {
        setAutomataEditMode(true);
        setAutomataLoading(true);
        getAutomataInfo();
        if (VMResponse.length === 0) {
            setVMModalOpen(true)
        }
    };

    function resourceAvailable() {
    }

    function editResourceAvailable() {
    }
    // function submit() {
    //     history.push('/completedRunAutomata')
    // }

    function addParameter() {
        setShowAddParameter(true);
    }

    const updateState = (state, stateValue) => {
        setParameterlength(stateValue);
        switch (state) {
            case 'parameterlength':
                setParameterlength(stateValue);
                break;
            case 'parameterNotAvailableOnlyDuration':
                setParameterNotAvailableOnlyDuration(stateValue);
                break;
            case 'showAddParameter':
                setShowAddParameter(stateValue);
                break;
            default:
        }

    };


    const filterDropdown = (id) => {
        if (props.incidentAutomata === true) {
            setSelectedItem(props.automatakey.name);
        }
        else {
            let input, filter, a, i, txtValue;
            let currentWorkingElement = [];
            input = document.getElementById(id);
            filter = input.value.toUpperCase();
            let div = document.getElementsByClassName("bx--list-box__wrapper");
            currentWorkingElement = Array.prototype.filter.call(
                div,
                function (el) { return el.getAttribute('aria-expanded') === 'true'; }
            );
            if (currentWorkingElement.length) {
                a = currentWorkingElement[0].getElementsByClassName("bx--list-box__menu-item");
                for (i = 0; i < a.length; i++) {
                    txtValue = a[i].textContent || a[i].innerText;
                    if (txtValue.toUpperCase().indexOf(filter) > -1) {
                        a[i].style.display = "";
                    } else {
                        a[i].style.display = "none";
                        setSelectedItem(a[i]);
                    }
                }
            }
        }
    };

    const handleExpectedDurationChange = (e) => {
        setExpectedDuration(e.target.value)
        console.log(expectedDuration)
    }
    const handleParameterInputChange = (e, index) => {
        var list = [];
        for (var i = 0; i < availableParameter.length; i++) {
            var Object = {};
            Object['name'] = availableParameter[i].name ? availableParameter[i].name : '';
            Object['type'] = availableParameter[i].type ? availableParameter[i].type : '';
            Object['value'] = availableParameter[i].value ? availableParameter[i].value : '';
            list.push(Object);
        }
        const { id, value } = e.target;
        list[index][id] = value;
        setAvailableParameter(list)
    };

    const itemToString = (item) => {
        console.log(item);
        if (props.incidentAutomata === true) {
            return props.automatakey.name
        }
        else {
            return item.name;
        }
    }

    return (

        <div>{parameterLoading === true ? <Loading /> :
            <div className="run-automata">

                {props.incidentAutomata === true ? '' : <div className="page-header">
                    <div>
                        {/* <Breadcrumb aria-label="Page navigation">
                            <BreadcrumbItem href='/'>
                                {home}
                            </BreadcrumbItem>
                            <BreadcrumbItem href='/automata'>
                                {runAutomata}
                            </BreadcrumbItem>
                        </Breadcrumb>
                        <div className="title">
                            {title}
                        </div> */}
                    </div>
                </div>
                }
                <div>
                    <Modal
                        danger
                        modalHeading={Warning}
                        modalLabel={overrideExistingSchedule}
                        primaryButtonText={Run}
                        secondaryButtonText={Cancel}
                        open={showOverrideModal}
                        size="md"
                        onRequestClose={closeOverrideModal}
                    >
                    </Modal>
                </div>
                <div className="automata-items">
                    <div className="form-container" style={props.incidentAutomata === true ? { width: '950px' } : { width: '1231.33px' }}>
                        <div className="form">
                            <div className="title carbon-display-Regular-20">
                                {pickAnAutomata}
                            </div>
                            <div className="form-row">
                                <div>
                                    <ComboBox
                                        ariaLabel="automata"
                                        id="automata"
                                        placeholder={SelectAutomata}
                                        titleText={automataDropdownTitle}
                                        label={automataDropdownLabel}
                                        onChange={(e) => setSelectedAutomata(e)}
                                        items={props.incidentAutomata === true ? automataRunList : automataList}
                                        itemToString={(item) => itemToString(item)}
                                        selectedItem={selectedItems}
                                        disabled={automataEditMode}
                                        onInputChange={() => filterDropdown("automata")}
                                    />

                                </div>

                                {automataEditMode ?
                                    <div>
                                        <Button renderIcon={Edit16} onClick={editAutomata}>{chooseLabel}</Button>
                                    </div>
                                    :
                                    <div>
                                        <Button renderIcon={ArrowRight16} onClick={saveAutomata}>{nextLabel}</Button>
                                    </div>}
                                <Modal open={VMModalOpen} onRequestClose={() => setVMModalOpen(false)} passiveModal modalHeading={VmDetailsNotFound} size="md" />

                            </div>
                        </div>
                    </div>
                    {automataEditMode &&
                        <div className="form-container" style={props.incidentAutomata === true ? { width: '950px' } : { width: '1231.33px' }}>
                            <div className="form">
                                <div className="title carbon-display-Regular-20">
                                    {editParametersLabel}
                                </div>
                                <div className="edit-parameter-container">
                                    <div className="run-duration">
                                        <TextInput
                                            type="number"
                                            labelText={ExpectedAutomataRunDuration}
                                            placeholder=""
                                            // disabled="false"
                                            defaultValue={expectedDuration}
                                            onChange={e => handleExpectedDurationChange(e)}
                                        />
                                        {!parameterNotAvailableOnlyDuration && !showAddParameter && parameterlength === 0 ?
                                            <div className="add-parameter">
                                                <Button renderIcon={Add16} onClick={addParameter}>{addLabel}</Button>
                                            </div> : null}
                                    </div>
                                    <div className="parameter-section">
                                        {/* {showAddParameter ?
                                            <div className="add-parameter-form">
                                                <AddParameter updateState={updateState} parameterlength={parameterlength} showAddParameter={showAddParameter} parameterNotAvailableOnlyDuration={parameterNotAvailableOnlyDuration}></AddParameter>
                                            </div> : null} */}
                                        {availableParameter && availableParameter.length > 0 && showAddParameter === false ? availableParameter.map((key, index) => {
                                            return (
                                                <div className="parameters">
                                                    <div>
                                                        <div className="parameter-name margin-left-20px">{parameterLabel} {index + 1}</div>
                                                        <div className="parameters-inputs margin-left-20px">
                                                            <div className="parameters-input">
                                                                <TextInput
                                                                    id="name"
                                                                    labelText={nameLabel}
                                                                    placeholder={namePlaceholder}
                                                                    disabled="true"
                                                                    defaultValue={key.name}
                                                                    onChange={e => handleParameterInputChange(e, index)}
                                                                />
                                                            </div>
                                                            <div className="parameters-input">
                                                                <TextInput
                                                                    id="type"
                                                                    labelText={typeLabel}
                                                                    placeholder={typePlaceholder}
                                                                    disabled="true"
                                                                    defaultValue={key.type}
                                                                    onChange={e => handleParameterInputChange(e, index)}
                                                                />
                                                            </div>
                                                            <div className="parameters-input">
                                                                <TextInput
                                                                    id="value"
                                                                    labelText={valueLabel}
                                                                    placeholder={valuePlaceholder}
                                                                    defaultValue={key.value}
                                                                    onChange={e => handleParameterInputChange(e, index)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>)
                                        }) : showAddParameter === false ? <Loading /> : null}
                                        {/* {availableParameter.length > 0 ?  */}
                                        {resourceLoading ? <Loading description={LoadingLabel} /> : null}

                                        <div className="margin-top-20px parameter-next-button">
                                            {VMResponse.length === 0 ?
                                                <Button renderIcon={ArrowRight16} disabled>{nextLabel}</Button>
                                                :
                                                expectedDuration !== "" || availableParameter.length !== 0 ?
                                                    <div>
                                                        {runautomataLoading ? <div className="center-screen">{waitingLabel}<Loading description={LoadingLabel} withOver /></div> : null}

                                                        <Button renderIcon={ArrowRight16} onClick={() => getRecommendedResource()}>{nextLabel}</Button>
                                                    </div> :
                                                    <Button renderIcon={ArrowRight16} disabled>{nextLabel}</Button>
                                            }
                                        </div>

                                        {/* : null} */}
                                    </div>
                                </div>

                                {/* <div className="form-row">
                                <div>
                                    <TextInput
                                        id="flag"
                                        labelText={flagLabel}
                                        defaultValue="False"
                                        onChange={(e) => updateTextInputValue(e, 'flag')}
                                    />
                                </div>
                            </div>
                            <div className="form-row">
                                <div>
                                    <TextInput
                                        id="count"
                                        labelText={countLabel}
                                        placeholder="Count"
                                        onChange={(e) => updateTextInputValue(e, 'count')}
                                    />
                                </div>
                                {automataEditMode &&
                                    <div className="submit">
                                        <Button onClick={handleSubmit}>{runLabel}</Button>
                                    </div>
                                }
                            </div>*/}

                            </div>

                            {showResource && <div className="form-container recommend-resource">
                                <div className="form resource-available">
                                    <div className="title carbon-display-Regular-20">
                                        {recomendedResource}
                                    </div>
                                    {resourceUnavailable ?
                                        <div className="notification-color">
                                            <InlineNotification
                                                kind="info"
                                                actions={<NotificationActionButton hideCloseButton="true"></NotificationActionButton>}
                                                iconDescription=""
                                                subtitle={""}
                                                title={ResourceUnavailable}
                                            />
                                        </div> : null}

                                    <div className="form-row">
                                        <div style={{ width: 300 }}>
                                            <Dropdown
                                                // disabled={automataEditMode}
                                                ariaLabel={resourceName}
                                                id="resourceName"
                                                items={recommendResourceList}
                                                itemToString={(item) => (item ? item : '')}
                                                titleText={recomendedResource}
                                                label={resourceName}
                                                onChange={setSelectedAutomataResource}
                                            />
                                        </div>
                                        {editResource ?
                                            <div>
                                                <Button renderIcon={Edit16} onClick={editResource}>{chooseLabel}</Button>
                                            </div> : null}
                                    </div>

                                </div>

                                {!resourceUnavailable ?

                                    <div className="submit">
                                        {selectedResource.length === 0 ?
                                            <Button renderIcon={ArrowRight16} onClick={handleSubmit} disabled>{runLabel}</Button>
                                            : <div>

                                                <Button renderIcon={ArrowRight16} onClick={handleSubmit}>{runLabel}</Button>

                                            </div>}

                                    </div> :
                                    <div className="form conflict">
                                        <ConflictingScheduleTable />
                                        <div className="conflict-buttons margin-top-20px">
                                            <div>
                                                <Button renderIcon={Calendar16}>{slotLabel}</Button>
                                            </div>
                                            <div className="margin-right-10px">
                                                <Button renderIcon={ArrowRight16} onClick={openOverrideModal}>{overrideLabel}</Button>
                                            </div>
                                        </div>
                                    </div>}
                            </div>}

                            {showAvailableSlot ?
                                <div className="form-container slots">
                                    <div className="form slot-available">
                                        <div className="title carbon-display-Regular-20">
                                            {"Next Available Slot for VM8667"}
                                        </div>
                                        <div>
                                            <TileGroup defaultSelected={"1"}>
                                                <RadioTile tabIndex={0} value="1" >
                                                    02/09/2021 t0 1000</RadioTile>
                                                <RadioTile tabIndex={0} value="2" >
                                                    02/10/2021 t0 1000
                                                </RadioTile>
                                                <RadioTile tabIndex={0} value="3" >
                                                    02/11/2021 t0 1000
                                                </RadioTile>
                                            </TileGroup>
                                        </div>
                                    </div>

                                    <div className="submit-slots">
                                        <Button renderIcon={ArrowRight16} onClick={handleSubmit}>{runLabel}</Button>

                                    </div>

                                </div> : null}

                        </div>
                    }
                    {/* {automataEditMode &&
                    <div className="submit">
                        <Button onClick={handleSubmit}>{runLabel}</Button>
                    </div>
                } */}
                </div>
            </div>
        }
        </div>
    );
};
export default CreateRunAutomataPage;
